// extracted by mini-css-extract-plugin
module.exports = {"root":"Pack_root_4dGU8","icon":"Pack_icon_3mvfR","desktop":"Pack_desktop_2HGff","mobile":"Pack_mobile_1_dS_"};